import { Divider, List, ListItem, ListItemText, Typography } from '@mui/material'
import { McpEvent } from './useAILive'

interface AILiveHistoryProps {
    events: McpEvent[]
}

export function AILiveHistory({ events }: AILiveHistoryProps): JSX.Element {
    return (
        <>
            <Typography variant="h6" sx={{ px: 2, py: 1, fontWeight: 700 }}>
                Session History
            </Typography>
            <Divider />
            {events.length === 0 ? (
                <Typography variant="body2" color="text.secondary" sx={{ px: 2, py: 2 }}>
                    Waiting for AI actions...
                </Typography>
            ) : (
                <List dense disablePadding>
                    {events.map((event, index) => (
                        <ListItem key={index} divider sx={{ alignItems: 'flex-start' }}>
                            <ListItemText
                                primary={event.description}
                                secondary={`${event.type} · ${new Date(event.timestamp).toLocaleTimeString()}`}
                                primaryTypographyProps={{ variant: 'body2' }}
                                secondaryTypographyProps={{ variant: 'caption' }}
                            />
                        </ListItem>
                    ))}
                </List>
            )}
        </>
    )
}
